# frozen_string_literal: true

module Engine
  module Game
    module G1822CaWrs
    end
  end
end
